export const TransferTypes = {
  COPY: 'copy',
  MERGE: 'merge',
}
